// src/defaultThemes.ts
var defaultMarkdownTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Crimson Text", "Georgia", "Times New Roman", serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#1a1a1a",
    background: "#ffffff",
    primary: "#007acc",
    secondary: "#005a9e",
    accent: "#1a1a1a",
    highlight: "#e6f4fb",
    muted: "#f0f0f0",
    success: "#28a745",
    warning: "#ffc107",
    error: "#dc3545",
    info: "#17a2b8",
    border: "#e6e6e6",
    backgroundSecondary: "#f8f9fa",
    backgroundTertiary: "#e9ecef",
    backgroundLight: "#f7f7f7",
    backgroundHover: "#f2f2f2",
    surface: "#ffffff",
    textSecondary: "#555555",
    textTertiary: "#888888",
    textMuted: "#aaaaaa",
    highlightBg: "#fff9c4",
    highlightBorder: "#fff389",
    textOnPrimary: "#ffffff"
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      "&:hover": { bg: "secondary" }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": { bg: "highlight" }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": { bg: "backgroundHover" }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    }
  }
};
var defaultTerminalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", Courier, monospace',
    heading: '"Courier New", Courier, monospace',
    monospace: '"Courier New", Courier, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.4,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.6
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 0 5px rgba(255, 193, 7, 0.1)",
    "0 0 10px rgba(255, 193, 7, 0.15)",
    "0 0 15px rgba(255, 193, 7, 0.2)",
    "0 0 20px rgba(255, 193, 7, 0.25)",
    "0 0 30px rgba(255, 193, 7, 0.3)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#ffc107",
    background: "#000000",
    primary: "#ffc107",
    secondary: "#ffb300",
    accent: "#ffffff",
    highlight: "#1a1301",
    muted: "#1a1a1a",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#332701",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#080600",
    backgroundHover: "#0d0a00",
    surface: "#050505",
    textSecondary: "#e0e0e0",
    textTertiary: "#b0b0b0",
    textMuted: "#808080",
    highlightBg: "#332701",
    highlightBorder: "#664d03",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": { bg: "secondary" }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": { bg: "highlight" }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": { bg: "backgroundHover" }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var defaultEditorTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Crimson Text", "Georgia", "Times New Roman", serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px rgba(0, 0, 0, 0.05)",
    "0 2px 4px rgba(0, 0, 0, 0.1)",
    "0 4px 8px rgba(0, 0, 0, 0.15)",
    "0 8px 16px rgba(0, 0, 0, 0.2)",
    "0 12px 24px rgba(0, 0, 0, 0.25)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#d4d4d4",
    background: "#1e1e1e",
    primary: "#569cd6",
    secondary: "#408ac9",
    accent: "#c586c0",
    highlight: "#242b30",
    muted: "#2a2a2a",
    success: "#6a9955",
    warning: "#d18616",
    error: "#f44747",
    info: "#569cd6",
    border: "#343434",
    backgroundSecondary: "#252526",
    backgroundTertiary: "#333333",
    backgroundLight: "#252525",
    backgroundHover: "#292929",
    surface: "#252526",
    textSecondary: "#cccccc",
    textTertiary: "#999999",
    textMuted: "#666666",
    highlightBg: "#4b4724",
    highlightBorder: "#78702a",
    textOnPrimary: "#ffffff"
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      "&:hover": { bg: "secondary" }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": { bg: "highlight" }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": { bg: "backgroundHover" }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    }
  }
};
// src/landingPageTheme.ts
var landingPageTheme = {
  space: [0, 4, 8, 12, 16, 20, 24, 32, 40, 48, 64, 80, 100, 128],
  fonts: {
    body: 'Inter, "Geist Sans", system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    heading: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    monospace: '"SF Mono", Monaco, Inconsolata, "Fira Code", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.2,
    tight: 1.05,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px", "1400px"],
  sizes: [16, 32, 64, 128, 200, 240, 256, 300, 512, 740, 768, 820, 900, 1024, 1200, 1400, 1536],
  radii: [0, 2, 4, 6, 7, 8, 9, 10, 12, 14, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 4px 12px rgba(0, 194, 255, 0.4)",
    "0 6px 24px rgba(0, 194, 255, 0.1)",
    "0 8px 32px rgba(0, 0, 0, 0.4)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50, 1000],
  colors: {
    text: "#ffffff",
    background: "#000000",
    primary: "#00C2FF",
    secondary: "#0098CC",
    accent: "#0066FF",
    highlight: "#001d26",
    muted: "#1a1a1a",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#002733",
    backgroundSecondary: "#0a1628",
    backgroundTertiary: "#0f1c2e",
    backgroundLight: "#00080a",
    backgroundHover: "#00131a",
    surface: "#000000",
    textSecondary: "#d1d5db",
    textTertiary: "#9ca3af",
    textMuted: "#6b7280",
    highlightBg: "#403b0f",
    highlightBorder: "#80761e",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "#000000",
      bg: "#00C2FF",
      borderWidth: 0,
      padding: "8px 20px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#00D9FF"
      }
    },
    secondary: {
      color: "#00C2FF",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#003a4d",
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#00131a",
        borderColor: "#00C2FF"
      }
    },
    ghost: {
      color: "#00C2FF",
      bg: "transparent",
      borderWidth: 0,
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": {
        color: "#00D9FF",
        bg: "#00131a"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "#ffffff"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body",
      color: "text"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 4
    },
    secondary: {
      bg: "#000a0d",
      border: "1px solid",
      borderColor: "#002733",
      borderRadius: 4
    }
  }
};
var landingPageLightTheme = {
  ...landingPageTheme,
  colors: {
    text: "#1a1a1a",
    background: "#ffffff",
    primary: "#0098CC",
    secondary: "#00C2FF",
    accent: "#0066FF",
    highlight: "#e6f5fa",
    muted: "#f0f0f0",
    success: "#4caf50",
    warning: "#ff9800",
    error: "#f44336",
    info: "#2196f3",
    border: "#cceaf5",
    backgroundSecondary: "#f8f9fa",
    backgroundTertiary: "#e9ecef",
    backgroundLight: "#f7fcfd",
    backgroundHover: "#f2fafc",
    surface: "#ffffff",
    textSecondary: "#555555",
    textTertiary: "#888888",
    textMuted: "#aaaaaa",
    highlightBg: "#fff9c4",
    highlightBorder: "#fff389",
    textOnPrimary: "#ffffff"
  },
  buttons: {
    primary: {
      color: "#ffffff",
      bg: "#0098CC",
      borderWidth: 0,
      padding: "8px 20px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#007aa8"
      }
    },
    secondary: {
      color: "#0098CC",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "#b2e0f0",
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 600,
      cursor: "pointer",
      "&:hover": {
        bg: "#f2fafc",
        borderColor: "#0098CC"
      }
    },
    ghost: {
      color: "#0098CC",
      bg: "transparent",
      borderWidth: 0,
      padding: "8px 16px",
      fontSize: 14,
      fontWeight: 500,
      cursor: "pointer",
      "&:hover": {
        color: "#007aa8",
        bg: "#f2fafc"
      }
    }
  }
};

// src/themes.ts
var regalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Crimson Text", "Georgia", "Times New Roman", serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.25)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#f1e8dc",
    background: "#1a1f2e",
    primary: "#d4a574",
    secondary: "#e0b584",
    accent: "#c9b8a3",
    highlight: "#363338",
    muted: "#8b7968",
    success: "#5c8a72",
    warning: "#d4a574",
    error: "#a85751",
    info: "#d4a574",
    border: "#3f3a3c",
    backgroundSecondary: "#212738",
    backgroundTertiary: "#2d3446",
    backgroundLight: "#292a34",
    backgroundHover: "#363338",
    surface: "#212738",
    textSecondary: "#c9b8a3",
    textTertiary: "#8b7968",
    textMuted: "#8b7968",
    highlightBg: "#534724",
    highlightBorder: "#8c701a",
    textOnPrimary: "#1a1f2e"
  },
  buttons: {
    primary: {
      color: "background",
      bg: "primary",
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "text",
      bg: "muted",
      "&:hover": {
        bg: "backgroundSecondary"
      }
    },
    ghost: {
      color: "primary",
      bg: "transparent",
      "&:hover": {
        bg: "muted"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "background",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 2
    }
  }
};
var terminalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace',
    heading: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace',
    monospace: '"SF Mono", "Monaco", "Inconsolata", "Fira Code", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.4,
    relaxed: 1.8
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "0 2px 4px 0 rgba(0, 0, 0, 0.06)",
    "0 4px 6px 0 rgba(0, 0, 0, 0.07)",
    "0 8px 12px 0 rgba(0, 0, 0, 0.08)",
    "0 16px 24px 0 rgba(0, 0, 0, 0.10)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#e4e4e4",
    background: "#0a0a0a",
    primary: "#66b3ff",
    secondary: "#80c4ff",
    accent: "#66ff99",
    highlight: "#18283d",
    muted: "#1a1a1a",
    success: "#66ff99",
    warning: "#ffcc66",
    error: "#ff6666",
    info: "#66b3ff",
    border: "#1a1a1a",
    backgroundSecondary: "#0f0f0f",
    backgroundTertiary: "#141414",
    backgroundLight: "#0d0d0d",
    backgroundHover: "#0d1520",
    surface: "#0f0f0f",
    textSecondary: "#b3b3b3",
    textTertiary: "#808080",
    textMuted: "#666666",
    highlightBg: "#40391e",
    highlightBorder: "#7f7530",
    textOnPrimary: "#ffffff"
  },
  modes: {
    light: {
      text: "#1a1a1a",
      background: "#ffffff",
      primary: "#0066cc",
      secondary: "#0052a3",
      accent: "#00cc88",
      highlight: "#e6f2ff",
      muted: "#f5f5f5",
      success: "#00cc88",
      warning: "#ffaa00",
      error: "#ff3333",
      info: "#0066cc",
      border: "#e6e6e6",
      backgroundSecondary: "#fafafa",
      backgroundTertiary: "#f5f5f5",
      backgroundLight: "#fafafa",
      backgroundHover: "#f5f9fd",
      surface: "#ffffff",
      textSecondary: "#666666",
      textTertiary: "#999999",
      textMuted: "#b3b3b3",
      highlightBg: "#fff9c4",
      highlightBorder: "#fff389"
    }
  },
  buttons: {
    primary: {
      color: "white",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "highlight"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 1
    }
  }
};
var matrixTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    heading: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    monospace: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 0 5px rgba(0, 216, 53, 0.15)",
    "0 0 10px rgba(0, 216, 53, 0.2)",
    "0 0 15px rgba(0, 216, 53, 0.25)",
    "0 0 20px rgba(0, 216, 53, 0.3)",
    "0 0 30px rgba(0, 216, 53, 0.4)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#a8a8a8",
    background: "#000000",
    primary: "#00d835",
    secondary: "#00a828",
    accent: "#00d835",
    highlight: "#002008",
    muted: "#0a0a0a",
    success: "#00d835",
    warning: "#d4a000",
    error: "#d63333",
    info: "#00a8d6",
    border: "#002b0b",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#000602",
    backgroundHover: "#001104",
    surface: "#050505",
    textSecondary: "#808080",
    textTertiary: "#606060",
    textMuted: "#484848",
    highlightBg: "#00360d",
    highlightBorder: "#006c1b",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "highlight"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var matrixMinimalTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    heading: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace',
    monospace: '"Courier New", "Courier", "Lucida Console", "Monaco", monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 500,
    bold: 600,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.5,
    heading: 1.2,
    tight: 1.3,
    relaxed: 1.7
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 2px rgba(0, 0, 0, 0.05)",
    "0 2px 4px rgba(0, 0, 0, 0.1)",
    "0 4px 8px rgba(0, 0, 0, 0.15)",
    "0 8px 16px rgba(0, 0, 0, 0.2)",
    "0 0 20px rgba(0, 216, 53, 0.1)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#a8a8a8",
    background: "#000000",
    primary: "#b8b8b8",
    secondary: "#909090",
    accent: "#00d835",
    highlight: "#001605",
    muted: "#0a0a0a",
    success: "#00d835",
    warning: "#d4a000",
    error: "#d63333",
    info: "#00a8d6",
    border: "#121212",
    backgroundSecondary: "#0a0a0a",
    backgroundTertiary: "#111111",
    backgroundLight: "#040404",
    backgroundHover: "#000b03",
    surface: "#050505",
    textSecondary: "#808080",
    textTertiary: "#606060",
    textMuted: "#484848",
    highlightBg: "#002b0b",
    highlightBorder: "#005615",
    textOnPrimary: "#000000"
  },
  buttons: {
    primary: {
      color: "black",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "secondary"
      }
    },
    secondary: {
      color: "primary",
      bg: "transparent",
      borderWidth: 1,
      borderStyle: "solid",
      borderColor: "primary",
      "&:hover": {
        bg: "backgroundHover"
      }
    },
    ghost: {
      color: "text",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textSecondary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 0
    }
  }
};
var slateTheme = {
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fonts: {
    body: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    heading: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    monospace: '"Fira Code", "SF Mono", Monaco, Inconsolata, monospace'
  },
  fontSizes: [12, 14, 16, 18, 20, 24, 32, 48, 64, 96],
  fontScale: 1,
  fontWeights: {
    body: 400,
    heading: 600,
    bold: 700,
    light: 300,
    medium: 500,
    semibold: 600
  },
  lineHeights: {
    body: 1.6,
    heading: 1.3,
    tight: 1.25,
    relaxed: 1.75
  },
  breakpoints: ["640px", "768px", "1024px", "1280px"],
  sizes: [16, 32, 64, 128, 256, 512, 768, 1024, 1536],
  radii: [0, 2, 4, 6, 8, 12, 16, 24],
  shadows: [
    "none",
    "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
    "0 4px 6px -1px rgba(0, 0, 0, 0.2)",
    "0 10px 15px -3px rgba(0, 0, 0, 0.2)",
    "0 20px 25px -5px rgba(0, 0, 0, 0.25)",
    "0 25px 50px -12px rgba(0, 0, 0, 0.3)"
  ],
  zIndices: [0, 1, 10, 20, 30, 40, 50],
  colors: {
    text: "#9ca3af",
    background: "#1a1c1e",
    primary: "#d1d5db",
    secondary: "#6b7280",
    accent: "#f59e0b",
    highlight: "#353838",
    muted: "#2d3134",
    success: "#10b981",
    warning: "#f59e0b",
    error: "#ef4444",
    info: "#3b82f6",
    border: "#2d3034",
    backgroundSecondary: "#22252a",
    backgroundTertiary: "#2d3134",
    backgroundLight: "#202325",
    backgroundHover: "#27292c",
    surface: "#1f2124",
    textSecondary: "#e5e7eb",
    textTertiary: "#6b7280",
    textMuted: "#4b5563",
    highlightBg: "#513c19",
    highlightBorder: "#875d14",
    textOnPrimary: "#1a1c1e"
  },
  buttons: {
    primary: {
      color: "#1a1c1e",
      bg: "primary",
      borderWidth: 0,
      "&:hover": {
        bg: "#9ca3af"
      }
    },
    secondary: {
      color: "#e5e7eb",
      bg: "secondary",
      borderWidth: 0,
      "&:hover": {
        bg: "#4b5563"
      }
    },
    ghost: {
      color: "textSecondary",
      bg: "transparent",
      "&:hover": {
        bg: "backgroundHover"
      }
    }
  },
  text: {
    heading: {
      fontFamily: "heading",
      fontWeight: "heading",
      lineHeight: "heading",
      color: "textSecondary"
    },
    body: {
      fontFamily: "body",
      fontWeight: "body",
      lineHeight: "body"
    },
    caption: {
      fontSize: 1,
      color: "textTertiary"
    }
  },
  cards: {
    primary: {
      bg: "surface",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 3
    },
    secondary: {
      bg: "backgroundSecondary",
      border: "1px solid",
      borderColor: "border",
      borderRadius: 3
    }
  }
};
// src/ThemeProvider.tsx
import React, { createContext, useContext, useState, useEffect } from "react";

// src/themeHelpers.ts
function overrideColors(theme, colors) {
  return {
    ...theme,
    colors: {
      ...theme.colors,
      ...colors
    }
  };
}
function makeTheme(baseTheme, overrides) {
  return {
    ...baseTheme,
    ...overrides,
    colors: {
      ...baseTheme.colors,
      ...overrides.colors
    },
    fonts: {
      ...baseTheme.fonts,
      ...overrides.fonts
    }
  };
}
function addMode(theme, modeName, colors, baseMode) {
  let baseColors;
  if (baseMode && theme.modes && theme.modes[baseMode]) {
    baseColors = {
      ...theme.colors,
      ...theme.modes[baseMode]
    };
  } else {
    baseColors = theme.colors;
  }
  const newMode = {
    ...baseColors,
    ...colors
  };
  return {
    ...theme,
    modes: {
      ...theme.modes,
      [modeName]: newMode
    }
  };
}
function getMode(theme, mode) {
  if (!mode || !theme.modes || !theme.modes[mode]) {
    return theme.colors;
  }
  return {
    ...theme.colors,
    ...theme.modes[mode]
  };
}

// src/ThemeProvider.tsx
var ThemeContext;
var getThemeContext = () => {
  if (typeof window !== "undefined") {
    const globalWindow = window;
    if (!globalWindow.__principlemd_theme_context__) {
      globalWindow.__principlemd_theme_context__ = createContext(undefined);
    }
    return globalWindow.__principlemd_theme_context__;
  } else {
    if (!ThemeContext) {
      ThemeContext = createContext(undefined);
    }
    return ThemeContext;
  }
};
var ThemeContextSingleton = getThemeContext();
var useTheme = () => {
  const context = useContext(ThemeContextSingleton);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
};
var ThemeProvider = ({
  children,
  theme: customTheme = theme,
  initialMode
}) => {
  const [mode, setMode] = useState(initialMode);
  const activeTheme = React.useMemo(() => {
    if (!mode || !customTheme.modes || !customTheme.modes[mode]) {
      return customTheme;
    }
    return {
      ...customTheme,
      colors: getMode(customTheme, mode)
    };
  }, [customTheme, mode]);
  useEffect(() => {
    if (!initialMode) {
      const savedMode = localStorage.getItem("principlemd-theme-mode");
      if (savedMode) {
        setMode(savedMode);
      }
    }
  }, [initialMode]);
  useEffect(() => {
    if (mode) {
      localStorage.setItem("principlemd-theme-mode", mode);
    } else {
      localStorage.removeItem("principlemd-theme-mode");
    }
  }, [mode]);
  const value = {
    theme: activeTheme,
    mode,
    setMode
  };
  return /* @__PURE__ */ React.createElement(ThemeContextSingleton.Provider, {
    value
  }, children);
};
var withTheme = (Component) => {
  return (props) => {
    const { theme: theme2 } = useTheme();
    return /* @__PURE__ */ React.createElement(Component, {
      ...props,
      theme: theme2
    });
  };
};
// src/utils.ts
var getColor = (theme2, colorKey) => {
  const colors = theme2.colors;
  const value = colors[colorKey];
  return typeof value === "string" ? value : colorKey;
};
var getSpace = (theme2, index) => {
  return theme2.space[index] || 0;
};
var getFontSize = (theme2, index) => {
  return theme2.fontSizes[index] || theme2.fontSizes[2];
};
var getRadius = (theme2, index) => {
  return theme2.radii[index] || 0;
};
var getShadow = (theme2, index) => {
  return theme2.shadows[index] || "none";
};
var getZIndex = (theme2, index) => {
  return theme2.zIndices[index] || 0;
};
var responsive = (values) => {
  return values.reduce((acc, value, index) => {
    if (index === 0) {
      return value;
    }
    return {
      ...acc,
      [`@media screen and (min-width: ${values[index - 1]})`]: value
    };
  }, {});
};
var sx = (styles) => styles;
var createStyle = (theme2, styleObj) => {
  const processValue = (value) => {
    if (typeof value === "string") {
      if (value in theme2.colors) {
        return getColor(theme2, value);
      }
      return value;
    }
    if (typeof value === "number") {
      return value;
    }
    if (Array.isArray(value)) {
      return value.map(processValue);
    }
    if (typeof value === "object" && value !== null) {
      const processed2 = {};
      for (const [key, val] of Object.entries(value)) {
        processed2[key] = processValue(val);
      }
      return processed2;
    }
    return value;
  };
  const processed = {};
  for (const [key, val] of Object.entries(styleObj)) {
    processed[key] = processValue(val);
  }
  return processed;
};
var mergeThemes = (baseTheme, ...overrides) => {
  return overrides.reduce((theme2, override) => ({
    space: override.space || theme2.space,
    fonts: { ...theme2.fonts, ...override.fonts || {} },
    fontSizes: override.fontSizes || theme2.fontSizes,
    fontWeights: { ...theme2.fontWeights, ...override.fontWeights || {} },
    lineHeights: { ...theme2.lineHeights, ...override.lineHeights || {} },
    breakpoints: override.breakpoints || theme2.breakpoints,
    sizes: override.sizes || theme2.sizes,
    radii: override.radii || theme2.radii,
    shadows: override.shadows || theme2.shadows,
    zIndices: override.zIndices || theme2.zIndices,
    colors: {
      ...theme2.colors,
      ...override.colors || {}
    },
    buttons: { ...theme2.buttons, ...override.buttons || {} },
    text: { ...theme2.text, ...override.text || {} },
    cards: { ...theme2.cards, ...override.cards || {} }
  }), baseTheme);
};
// src/ThemeShowcase.tsx
import React2 from "react";
var ThemeShowcase = ({
  theme: theme2,
  title,
  showValues = true,
  sections = ["colors", "typography", "spacing", "shadows", "radii"]
}) => {
  const containerStyle = {
    fontFamily: theme2.fonts.body,
    color: theme2.colors.text,
    backgroundColor: theme2.colors.background,
    padding: theme2.space[4],
    minHeight: "100vh"
  };
  const sectionStyle = {
    marginBottom: theme2.space[5],
    padding: theme2.space[4],
    backgroundColor: theme2.colors.surface || theme2.colors.backgroundSecondary,
    borderRadius: theme2.radii[2],
    border: `1px solid ${theme2.colors.border}`
  };
  const headingStyle = {
    fontFamily: theme2.fonts.heading,
    fontSize: theme2.fontSizes[5],
    fontWeight: theme2.fontWeights.heading,
    marginBottom: theme2.space[3],
    color: theme2.colors.primary
  };
  const subheadingStyle = {
    fontFamily: theme2.fonts.heading,
    fontSize: theme2.fontSizes[3],
    fontWeight: theme2.fontWeights.medium,
    marginBottom: theme2.space[2],
    marginTop: theme2.space[3],
    color: theme2.colors.text
  };
  return /* @__PURE__ */ React2.createElement("div", {
    style: containerStyle
  }, title && /* @__PURE__ */ React2.createElement("h1", {
    style: {
      ...headingStyle,
      fontSize: theme2.fontSizes[6],
      marginBottom: theme2.space[4]
    }
  }, title), sections.includes("colors") && /* @__PURE__ */ React2.createElement("div", {
    style: sectionStyle
  }, /* @__PURE__ */ React2.createElement("h2", {
    style: headingStyle
  }, "Colors"), /* @__PURE__ */ React2.createElement("h3", {
    style: subheadingStyle
  }, "Primary Colors"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: theme2.space[3],
      marginBottom: theme2.space[3]
    }
  }, ["text", "background", "primary", "secondary", "accent", "muted"].map((key) => {
    const color = theme2.colors[key];
    if (!color)
      return null;
    return /* @__PURE__ */ React2.createElement("div", {
      key,
      style: {
        display: "flex",
        alignItems: "center",
        padding: theme2.space[2],
        backgroundColor: theme2.colors.backgroundLight || theme2.colors.backgroundTertiary,
        borderRadius: theme2.radii[1]
      }
    }, /* @__PURE__ */ React2.createElement("div", {
      style: {
        width: 40,
        height: 40,
        backgroundColor: color,
        border: `1px solid ${theme2.colors.border}`,
        borderRadius: theme2.radii[1],
        marginRight: theme2.space[2]
      }
    }), /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement("div", {
      style: {
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[1],
        fontWeight: theme2.fontWeights.medium
      }
    }, key), showValues && /* @__PURE__ */ React2.createElement("div", {
      style: {
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary
      }
    }, color)));
  })), /* @__PURE__ */ React2.createElement("h3", {
    style: subheadingStyle
  }, "Status Colors"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: theme2.space[3],
      marginBottom: theme2.space[3]
    }
  }, ["success", "warning", "error", "info"].map((key) => {
    const color = theme2.colors[key];
    if (!color)
      return null;
    return /* @__PURE__ */ React2.createElement("div", {
      key,
      style: {
        display: "flex",
        alignItems: "center",
        padding: theme2.space[2],
        backgroundColor: theme2.colors.backgroundLight || theme2.colors.backgroundTertiary,
        borderRadius: theme2.radii[1]
      }
    }, /* @__PURE__ */ React2.createElement("div", {
      style: {
        width: 40,
        height: 40,
        backgroundColor: color,
        border: `1px solid ${theme2.colors.border}`,
        borderRadius: theme2.radii[1],
        marginRight: theme2.space[2]
      }
    }), /* @__PURE__ */ React2.createElement("div", null, /* @__PURE__ */ React2.createElement("div", {
      style: {
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[1],
        fontWeight: theme2.fontWeights.medium
      }
    }, key), showValues && /* @__PURE__ */ React2.createElement("div", {
      style: {
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary
      }
    }, color)));
  })), /* @__PURE__ */ React2.createElement("h3", {
    style: subheadingStyle
  }, "Background Colors"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
      gap: theme2.space[3]
    }
  }, [
    "backgroundSecondary",
    "backgroundTertiary",
    "backgroundLight",
    "backgroundHover",
    "surface"
  ].map((key) => {
    const color = theme2.colors[key];
    if (!color)
      return null;
    return /* @__PURE__ */ React2.createElement("div", {
      key,
      style: {
        padding: theme2.space[3],
        backgroundColor: color,
        border: `1px solid ${theme2.colors.border}`,
        borderRadius: theme2.radii[1]
      }
    }, /* @__PURE__ */ React2.createElement("div", {
      style: {
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[1],
        fontWeight: theme2.fontWeights.medium
      }
    }, key), showValues && /* @__PURE__ */ React2.createElement("div", {
      style: {
        fontFamily: theme2.fonts.monospace,
        fontSize: theme2.fontSizes[0],
        color: theme2.colors.textSecondary,
        marginTop: theme2.space[1]
      }
    }, color));
  }))), sections.includes("typography") && /* @__PURE__ */ React2.createElement("div", {
    style: sectionStyle
  }, /* @__PURE__ */ React2.createElement("h2", {
    style: headingStyle
  }, "Typography"), /* @__PURE__ */ React2.createElement("h3", {
    style: subheadingStyle
  }, "Font Families"), /* @__PURE__ */ React2.createElement("div", {
    style: { marginBottom: theme2.space[4] }
  }, /* @__PURE__ */ React2.createElement("div", {
    style: {
      fontFamily: theme2.fonts.heading,
      fontSize: theme2.fontSizes[4],
      marginBottom: theme2.space[2]
    }
  }, "Heading Font:", " ", showValues && /* @__PURE__ */ React2.createElement("span", {
    style: {
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary
    }
  }, " ", theme2.fonts.heading)), /* @__PURE__ */ React2.createElement("div", {
    style: {
      fontFamily: theme2.fonts.body,
      fontSize: theme2.fontSizes[2],
      marginBottom: theme2.space[2]
    }
  }, "Body Font:", " ", showValues && /* @__PURE__ */ React2.createElement("span", {
    style: {
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary
    }
  }, " ", theme2.fonts.body)), /* @__PURE__ */ React2.createElement("div", {
    style: {
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[2]
    }
  }, "Monospace Font:", " ", showValues && /* @__PURE__ */ React2.createElement("span", {
    style: {
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary
    }
  }, " ", theme2.fonts.monospace))), /* @__PURE__ */ React2.createElement("h3", {
    style: subheadingStyle
  }, "Font Sizes"), /* @__PURE__ */ React2.createElement("div", {
    style: { marginBottom: theme2.space[4] }
  }, theme2.fontSizes.map((size, index) => /* @__PURE__ */ React2.createElement("div", {
    key: index,
    style: {
      fontSize: size,
      lineHeight: theme2.lineHeights.body,
      marginBottom: theme2.space[1]
    }
  }, "Size ", index, ": Sample Text ", showValues && `(${size}px)`))), /* @__PURE__ */ React2.createElement("h3", {
    style: subheadingStyle
  }, "Font Weights"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
      gap: theme2.space[2]
    }
  }, Object.entries(theme2.fontWeights).map(([name, weight]) => /* @__PURE__ */ React2.createElement("div", {
    key: name,
    style: {
      fontWeight: weight,
      fontSize: theme2.fontSizes[2]
    }
  }, name, " ", showValues && `(${weight})`)))), sections.includes("spacing") && /* @__PURE__ */ React2.createElement("div", {
    style: sectionStyle
  }, /* @__PURE__ */ React2.createElement("h2", {
    style: headingStyle
  }, "Spacing"), /* @__PURE__ */ React2.createElement("div", {
    style: { display: "flex", flexDirection: "column", gap: theme2.space[2] }
  }, theme2.space.map((space, index) => /* @__PURE__ */ React2.createElement("div", {
    key: index,
    style: { display: "flex", alignItems: "center" }
  }, /* @__PURE__ */ React2.createElement("div", {
    style: {
      width: 60,
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary
    }
  }, "[", index, "]"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      height: 24,
      width: space,
      backgroundColor: theme2.colors.primary,
      borderRadius: theme2.radii[1]
    }
  }), showValues && /* @__PURE__ */ React2.createElement("div", {
    style: {
      marginLeft: theme2.space[2],
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[1],
      color: theme2.colors.textSecondary
    }
  }, space, "px"))))), sections.includes("radii") && /* @__PURE__ */ React2.createElement("div", {
    style: sectionStyle
  }, /* @__PURE__ */ React2.createElement("h2", {
    style: headingStyle
  }, "Border Radii"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
      gap: theme2.space[3]
    }
  }, theme2.radii.map((radius, index) => /* @__PURE__ */ React2.createElement("div", {
    key: index,
    style: { textAlign: "center" }
  }, /* @__PURE__ */ React2.createElement("div", {
    style: {
      width: 80,
      height: 80,
      backgroundColor: theme2.colors.primary,
      borderRadius: radius,
      marginBottom: theme2.space[1],
      margin: "0 auto"
    }
  }), /* @__PURE__ */ React2.createElement("div", {
    style: {
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary
    }
  }, "[", index, "] ", showValues && `${radius}px`))))), sections.includes("shadows") && /* @__PURE__ */ React2.createElement("div", {
    style: sectionStyle
  }, /* @__PURE__ */ React2.createElement("h2", {
    style: headingStyle
  }, "Shadows"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
      gap: theme2.space[4]
    }
  }, theme2.shadows.map((shadow, index) => /* @__PURE__ */ React2.createElement("div", {
    key: index,
    style: { textAlign: "center" }
  }, /* @__PURE__ */ React2.createElement("div", {
    style: {
      width: 100,
      height: 100,
      backgroundColor: theme2.colors.background,
      boxShadow: shadow,
      borderRadius: theme2.radii[2],
      margin: "0 auto",
      marginBottom: theme2.space[2],
      border: `1px solid ${theme2.colors.border}`
    }
  }), /* @__PURE__ */ React2.createElement("div", {
    style: {
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textSecondary
    }
  }, "Shadow [", index, "]"), showValues && /* @__PURE__ */ React2.createElement("div", {
    style: {
      fontFamily: theme2.fonts.monospace,
      fontSize: theme2.fontSizes[0],
      color: theme2.colors.textMuted,
      marginTop: theme2.space[1]
    }
  }, shadow === "none" ? "none" : "..."))))), theme2.modes && Object.keys(theme2.modes).length > 0 && /* @__PURE__ */ React2.createElement("div", {
    style: sectionStyle
  }, /* @__PURE__ */ React2.createElement("h2", {
    style: headingStyle
  }, "Available Modes"), /* @__PURE__ */ React2.createElement("div", {
    style: {
      display: "flex",
      gap: theme2.space[2],
      flexWrap: "wrap"
    }
  }, /* @__PURE__ */ React2.createElement("div", {
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      backgroundColor: theme2.colors.primary,
      color: "#ffffff",
      borderRadius: theme2.radii[2],
      fontFamily: theme2.fonts.body,
      fontSize: theme2.fontSizes[1]
    }
  }, "default"), Object.keys(theme2.modes).map((modeName) => /* @__PURE__ */ React2.createElement("div", {
    key: modeName,
    style: {
      padding: `${theme2.space[2]}px ${theme2.space[3]}px`,
      backgroundColor: theme2.colors.secondary,
      color: theme2.colors.text,
      borderRadius: theme2.radii[2],
      fontFamily: theme2.fonts.body,
      fontSize: theme2.fontSizes[1]
    }
  }, modeName)))));
};

// src/index.ts
var theme = terminalTheme;
function scaleThemeFonts(theme2, scale) {
  const currentScale = theme2.fontScale || 1;
  const effectiveScale = scale / currentScale;
  return {
    ...theme2,
    fontSizes: theme2.fontSizes.map((size) => Math.round(size * effectiveScale)),
    fontScale: scale
  };
}
function increaseFontScale(theme2) {
  const currentScale = theme2.fontScale || 1;
  const newScale = Math.min(currentScale * 1.1, 2);
  return scaleThemeFonts(theme2, newScale);
}
function decreaseFontScale(theme2) {
  const currentScale = theme2.fontScale || 1;
  const newScale = Math.max(currentScale * 0.9, 0.5);
  return scaleThemeFonts(theme2, newScale);
}
function resetFontScale(theme2) {
  return scaleThemeFonts(theme2, 1);
}
var src_default = theme;
export {
  withTheme,
  useTheme,
  theme,
  terminalTheme,
  sx,
  slateTheme,
  scaleThemeFonts,
  responsive,
  resetFontScale,
  regalTheme,
  overrideColors,
  mergeThemes,
  matrixTheme,
  matrixMinimalTheme,
  makeTheme,
  landingPageTheme,
  landingPageLightTheme,
  increaseFontScale,
  getZIndex,
  getSpace,
  getShadow,
  getRadius,
  getMode,
  getFontSize,
  getColor,
  defaultTerminalTheme,
  defaultMarkdownTheme,
  defaultEditorTheme,
  src_default as default,
  decreaseFontScale,
  createStyle,
  addMode,
  ThemeShowcase,
  ThemeProvider
};
